<form [formGroup]="filterGamesTable">
  <div
    class="bg-white w-full h-auto grid grid-cols-3 gap-3 p-6 rounded-xl {{
      customClass
    }}"
  >
    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Evento"
        formControlName="evento"
        [options]="eventOptions?.content ?? []"
        optionIdentify="eveNrId"
        optionLabel="eveTxNome"
        searchble
        (searchChange)="eventSearchChange($event)"
        (changeOption)="handleEventChange($event?.eveNrId)"
        paged
        (pageChange)="changeEventPage($event)"
        [totalPages]="eventOptions?.totalPages || 1"
        [currentPage]="eventOptions?.number || 0"
      />
    </div>

    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Competição da modalidade"
        formControlName="competicao"
        [options]="competitionOptions?.content ?? []"
        optionIdentify="comNrId"
        optionLabel="comTxNome"
        [disabled]="!filterGamesTable.get('evento')?.value"
      />
    </div>

    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Fase"
        formControlName="fase"
        [options]="faseOptions?.content ?? []"
        (changeOption)="setPetNrId($event.petNrId)"
        optionIdentify="petNrId"
        optionLabel="petTxNome"
        paged
        (pageChange)="changeFasePage($event)"
        [totalPages]="faseOptions?.totalPages || 1"
        [currentPage]="faseOptions?.number || 0"
        searchble
        (searchChange)="searchFaseChange($event)"
      />
    </div>

    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Chave"
        formControlName="chave"
        [options]="clashOptions?.content ?? []"
        optionIdentify="cheNrId"
        optionLabel="cheTxNome"
        paged
        (pageChange)="changeClashPage($event)"
        [totalPages]="clashOptions?.totalPages || 1"
        [currentPage]="clashOptions?.number || 0"
        searchble
        (searchChange)="searchClashChange($event)"
      />
    </div>

    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Local de competição"
        optionIdentify="areNrId"
        optionLabel="areTxNome"
        formControlName="local"
        [lastValidSelectedOption]="
          isEditingFight
            ? selectedArena!
            : filterGamesTableService.selectedArena()!
        "
        (changeOption)="handleArenaChange($event!)"
        [options]="arenaOptions?.content ?? []"
        paged
        (pageChange)="arenaPageChange($event)"
        [currentPage]="arenaOptions?.number || 0"
        [totalPages]="arenaOptions?.totalPages || 1"
        searchble
        (searchChange)="arenaSearchChange($event)"
      />
    </div>

    <div class="col-span-1">
      <sigecom-new-dropdown
        label="Espaço"
        formControlName="espaco"
        optionIdentify="epcNrId"
        optionLabel="epcTxNome"
        [options]="spaceOptions ?? []"
      />
    </div>

    <div class="col-span-1">
      <sigecom-date-time-picker
        label="Data"
        [type]="DateTimeEnum.DATE"
        formControlName="competitonDate"
        sizeIcon="lg"
      />
    </div>
    <div class="col-span-1">
      <sigecom-date-time-picker
        label="Horário"
        [type]="DateTimeEnum.TIME"
        formControlName="competitonHour"
        sizeIcon="lg"
      />
    </div>

    <!-- <div class="col-span-1">
      <div
        class="rounded-md h-full pt-2 pl-2 pb-1.5 border border-solid border-gray-500"
      >
        <div class="flex items-center px-2">
          <span class="font-bold text-sm text-sigecom-gray">
            Horário
            <span *ngIf="isRequired('competitionHour')" class="text-sigecom-danger">
              {{ "*" }}
            </span>
          </span>
          <span class="text-sigecom-danger pl-1"></span>

          <fa-icon
            *ngIf="filterGamesTable.controls['competitionHour'].value"
            (click)="cleanCompetitonHour()"
            [icon]="['fas', 'xmark']"
            class="text-red-500 cursor-pointer text-sm"
          >
          </fa-icon>
        </div>
        <div class="relative">
          <input
            type="time"
            formControlName="competitionHour"
            class="w-full border-none rounded-lg focus:ring-0 focus:outline-none appearance-none bg-transparent"
          />

          <fa-icon
            size="lg"
            [icon]="['fas', 'clock']"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
          >
          </fa-icon>
        </div>
      </div>
    </div> -->
    <div
      *ngIf="!isEditingFight"
      class="w-full col-span-full flex justify-end text-white cursor-pointer font-normal text-sm"
    >
      <button class="bg-[#FF3B30] rounded-lg p-2.5" (click)="cleanAllFilters()">
        Limpar todos os filtros
      </button>
    </div>
  </div>
</form>
